// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryTilesStyles } from "@eisinc/App/Widgets/CategoryTilesDisplay/CategoryTiles";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import xScreen from "@eisinc/XDL/Utilities/xScreen";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

categoryTilesStyles.wrappingContainer = {
    css: css`
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(204px, 1fr));
        gap: 32px 22px;
        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(auto-fit, minmax(169px, 1fr));
            gap: 36px 20px;
        }
        ${xScreen("lt", "sm")} {
            grid-template-columns: repeat(auto-fit, minmax(156px, 1fr));
            gap: 32px 16px;
        }
    `,
};

categoryTilesStyles.spinnerWrapper = {
    css: css`
        width: 100%;
        min-height: 80px;
        display: flex;
        justify-content: cneter;
        align-items: center;
    `,
};

categoryTilesStyles.spinner = {
    color: "primary.main",
    css: css`
        margin: auto;
    `,
};

categoryTilesStyles.categoryTileWrapper = {
    css: css`
            display: flex;
            flex-direction: column;
            row-gap: 12px;
            align-items: center;
`,
};

categoryTilesStyles.categoryImage = {
    css: css`
        aspect-ratio: 204 / 166;
        height: 166px;
        ${xScreen("lte", "md")} {
            aspect-ratio: 169 / 138;
            height: 138px;
        }
        ${xScreen("lt", "sm")} {
            aspect-ratio: 156 / 127;
            height: 127px;
        }
        img {
            object-fit: contain;
            max-width: 100%;
            max-height: 100%;
        }
    `,
};

categoryTilesStyles.categoryText = {
    typographyProps: {
        size: fontConfig.regular.size,
        weight: fontConfig.weight.medium,
    },
    css: css`
        ${TypographyStyle} {
            color: ${color("text.main")};
            text-align: center;
            line-height: ${fontConfig.singleLineRegular.lineHeight};
        }
    `,
};
